import {Injectable} from '@angular/core';
import {UserFilters} from '../../data/models/filters/user-filters';
import {Page} from '../../data/models/page';
import {User} from '../../data/models/user';
import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient,
  ) {
  }


  addUser(data: {
    mail: string,
    password: string,
    surname?: string,
    name: string,
    patronymic?: string,
    roles?: number[],
  }): Promise<User> {

    const formData = new FormData();
    formData.append('mail', data.mail);
    formData.append('password', data.password);
    if (data.surname) {
      formData.append('surname', data.surname);
    }
    formData.append('name', data.name);
    if (data.patronymic) {
      formData.append('patronymic', data.patronymic);
    }
    if (data.roles) {
      for (const role of data.roles) {
        formData.append('roles', role.toString());
      }
    }

    return this.http.post<User>(`api/users`, formData)
      .toPromise();
  }


  getUser(userId: number): Promise<User> {
    return this.http.get<User>(`api/users/${userId}`)
      .toPromise();
  }


  blockUser(userId: number): Promise<User> {
    return this.http.post<User>(`api/users/${userId}/actions/block`, new FormData())
      .toPromise();
  }


  unblockUser(userId: number): Promise<User> {
    return this.http.post<User>(`api/users/${userId}/actions/unblock`, new FormData())
      .toPromise();
  }

  updateUser(userId: number, newData: {
    mail?: string,
    password?: string,
    surname?: string,
    name?: string,
    patronymic?: string,
    roles?: number[],
  }): Promise<User> {

    const formData = new FormData();
    if (newData.mail) {
      formData.append('mail', newData.mail);
    }
    if (newData.password) {
      formData.append('password', newData.password);
    }
    if (newData.surname) {
      formData.append('surname', newData.surname);
    }
    if (newData.name) {
      formData.append('name', newData.name);
    }
    if (newData.patronymic) {
      formData.append('patronymic', newData.patronymic);
    }
    if (newData.roles) {
      if (newData.roles.length === 0) {
        formData.append('roles', '0');
      }
      for (const role of newData.roles) {
        formData.append('roles', role.toString());
      }
    }

    return this.http.put<User>(`api/users/${userId}`, formData)
      .toPromise();
  }


  deleteUser(userId: number): Promise<void> {
    return this.http.delete<void>(`api/users/${userId}`)
      .toPromise();
  }


  searchUsers(
    filters: UserFilters,
    sort: any[], pageSize: number, pageNumber: number
  ): Promise<Page<User>> {

    let httpParams = new HttpParams()
      .set('size', pageSize.toString())
      .set('page', pageNumber.toString());

    if (filters.search && filters.search.length > 0) {
      httpParams = httpParams.set('search', filters.search);
    }

    if (filters.exactMail && filters.exactMail.length > 0) {
      httpParams = httpParams.set('exactMail', filters.exactMail);
    }

    if (filters.isDeleted !== undefined && filters.isDeleted !== null) {
      httpParams = httpParams.set('isDeleted', filters.isDeleted.toString());
    }

    if (sort.length > 0) {
      httpParams = httpParams.set('sort', sort.join(','));
    }

    return this.http.get<Page<User>>(`api/users`, {
      params: httpParams
    }).toPromise();
  }
}
